<div class="modal-container" [class.modal-container--stacked]="offerSaveChoice">
    <button class="close-icon" (click)="closeModal()" aria-label="Close">
        &times;
    </button>

    <div class="text-center">
        <h4 class="montserrat-bold text-uppercase text-gray-500 mb-4">Attention</h4>
        <p class="modal-message text-gray-500">{{ message }}</p>
    </div>

    <ng-container *ngIf="offerSaveChoice; else exitActions">
        <div class="modal-actions-stacked">
            <button class="btn btn-md btn-outline-gray-500" (click)="closeWithoutSaving()">
                {{ discardLabel }}
            </button>
            <button class="btn btn-md btn-outline-gray-500" (click)="saveAndClose()">
                {{ saveLabel }}
            </button>
            <button class="btn btn-md btn-gray-500" (click)="closeModal()">
                Keep editing
            </button>
        </div>
    </ng-container>

    <ng-template #exitActions>
        <div class="d-flex align-items-center justify-content-center mt-4">
            <button
                class="btn btn-md btn-outline-gray-500 mr-3"
                (click)="closeWithoutSaving()"
            >
                Close without Saving
            </button>
            <ng-container *ngIf="isVisualsWarning; else defaultSaveAction">
                <button
                    class="btn btn-md btn-gray-500"
                    (click)="closeModal()"
                >
                    OK
                </button>
            </ng-container>

            <ng-template #defaultSaveAction>
                <button
                    class="btn btn-md btn-gray-500"
                    (click)="saveAndClose()"
                >
                    Save and Close
                </button>
            </ng-template>
        </div>
    </ng-template>
</div>
